import { Box, styled } from "@mui/material";

export const Spacer = styled(Box)({ flexGrow: 1 });
